import AllergenList from '@/components/AllergenList'
import vuewidget from './vuewidget'

export default function(dom, opts) {
  let options = {
    vouchers: [],
    ...opts,
    vueComponent: AllergenList
  }

  let page = vuewidget(dom, options)
  return page
}
